import React, { createContext, useContext, ReactNode } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries: any = ["places", "marker"];

interface GoogleMapsLoaderContextType {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsLoaderContext =
  createContext<GoogleMapsLoaderContextType | null>(null);

export const useGoogleMapsLoader = () => {
  const context = useContext(GoogleMapsLoaderContext);
  if (!context) {
    throw new Error(
      "useGoogleMapsLoader must be used within a GoogleMapsLoaderProvider"
    );
  }
  return context;
};

interface GoogleMapsLoaderProviderProps {
  children: ReactNode;
}

export const GoogleMapsLoaderProvider: React.FC<
  GoogleMapsLoaderProviderProps
> = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  return (
    <GoogleMapsLoaderContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsLoaderContext.Provider>
  );
};
